var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":require("../../public/image/success.png"),"alt":""}}),_c('span',[_vm._v("支付成功")]),_c('router-link',{attrs:{"to":'/'}},[_c('div',[_vm._v("返回首页")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }